//import { v4 as uuidv4 } from 'uuid';

export const DnDSet1 = {
  "set1": [
    'Папа', 'Дедушка', 'Внук', 'Сын', 'Муж', 'Брат', 'Друг', 'Молодой человек'
  ],
  "set2": [
    'Мать', 'Дочь', 'Сестра', 'Подруга', 'Жена', 'Бабушка', 'Девушка', 'Внучка'
  ]
};